import {
  actionCreator,
  checkHttpStatus,
  jsonApiHeader,
  PatientDashboardActionTypes,
  GET_CHECKUSERPASSWORDSTATUS,
} from '../constants/ApiConstants';

// export const getAppConfiguration = () => {
//   return (dispatch, getState) => {
//     dispatch(actionCreator(StaffDashboardActionTypes.get_appConfig.REQUEST));
//     fetch(`${API_URL}/app-configuration`, {
//       method: 'GET',
//       headers: jsonApiHeader(getState().login.access_token, 'application/json'),
//     })
//       .then(checkHttpStatus)
//       .then(function(response) {
//         dispatch(actionCreator(StaffDashboardActionTypes.get_appConfig.SUCCESS, response));
//       })
//       .catch(function(error) {
//         console.log('get_app configuration error...', error);
//       });
//   };
// };



export const CheckClientPasswordStatus = () => {
  return (dispatch, getState) => {
    dispatch(actionCreator(PatientDashboardActionTypes.get_CheckUserPasswordStatus.REQUEST));
    fetch(`${GET_CHECKUSERPASSWORDSTATUS}`, {
      method: 'Get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        dispatch(actionCreator(PatientDashboardActionTypes.get_CheckUserPasswordStatus.SUCCESS, { passwordExpiryStatus: response}));
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  };
};


export const HideClientPasswordStatusMessage = () => {  
  return (dispatch, getState) => {
    dispatch(actionCreator(PatientDashboardActionTypes.get_CheckUserPasswordStatus.REQUEST));
  };
};



// WEBPACK FOOTER //
// ./src/modules/PatientPortal/containers/dashboard/actions/ClientDashboardActions.js